import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../variables';
import Search from './search';
import Filter from './filter';
import Sort from './sort';
import { generateKey } from '../../utils/utils';

const DynamicFilterBlock = ({
  updateQueryArray,
  setCompareFunctionConfig,
  elementData,
  className,
}) => {
  if (
    updateQueryArray &&
    setCompareFunctionConfig &&
    Array.isArray(elementData)
  ) {
    return (
      <div className={className}>
        {elementData.map((element, index) => {
          if (element.type === 'search') {
            return (
              <Search
                id={element.id}
                title={element.title}
                label={element.label}
                fields={element.fields}
                updateQueryArray={updateQueryArray}
                width={element.width}
                key={generateKey(element.title, index)}
              />
            );
          } else if (element.type === 'filter') {
            return (
              <Filter
                id={element.id}
                title={element.title}
                label={element.label}
                fields={element.fields}
                isExact={element.isExact}
                checkboxData={element.checkboxData}
                updateQueryArray={updateQueryArray}
                width={element.width}
                matchDropdownWidth={element.matchDropdownWidth}
                key={generateKey(element.id, index)}
              />
            );
          } else if (element.type === 'sort') {
            return (
              <Sort
                id={element.id}
                title={element.title}
                radioInputData={element.radioInputData}
                setCompareFunctionConfig={setCompareFunctionConfig}
                width={element.width}
                key={generateKey(element.id, index)}
              />
            );
          } else {
            console.warn(
              `DynamicFilterBlock -> element type not found: ${element.type}`
            );
            return null;
          }
        })}
      </div>
    );
  } else {
    console.warn(
      `DynamicFilterBlock received non valid arguments - updateQueryArray: ${updateQueryArray}, setCompareFunctionConfig: ${setCompareFunctionConfig}, elementData: ${elementData}`
    );
    return null;
  }
};

// === DynamicFilterBlock CSS ===
const StyledDynamicFilterBlock = styled(DynamicFilterBlock)`
  display: flex;
  flex-wrap: wrap;
  background-color: ${vars.greyHavens};
  padding: 0 2rem ${vars.spacingM} 2rem;
  @media screen and (min-width: ${vars.breakPointTwelveColumn}) {
    padding: 0 ${vars.spacingS} ${vars.spacingM} ${vars.spacingS};
  }
  .filter-block-element {
    margin-top: ${vars.spacingM};
    &:not(:last-of-type) {
      margin-right: ${vars.spacingS};
    }
  }
`;

export default StyledDynamicFilterBlock;
